<template>
  <v-card :elevation="0">
    <v-card-title class="ma-0 pa-0">
      <span :style="'color:'+color"
            class="font-weight-bold starling-body">
        {{ $t('assessments.' + userAssessment.assessmentName).label }}
        {{ userAssessment.scores.INTRINSIC.value }}
      </span>
      &nbsp;-&nbsp;
      {{ userAssessment.completed | moment('LLL') }}
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
      <assessment-notes-input :user-assessment="userAssessment" @updated="onUpdated"/>
    </v-card-text>
  </v-card>
</template>

<script>
import AssessmentNotesInput from '@/views/app/view_member/charts/assessment-notes-input';

export default {
  name: 'assessment-note-display',
  components: {AssessmentNotesInput},
  props: {
    userAssessment: Object
  },
  computed: {
    color () {
      return this.$t(`assessments.${this.userAssessment.assessmentName}`).color;
    }
  },
  methods: {
    onUpdated (updatedUserAssessment) {
      this.$emit('updated', updatedUserAssessment);
    }
  }
};
</script>

<style scoped>

</style>
